import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./clientCalendarStyle.css";
import CalendarHeader from "./calendar_header/CalendarHeader";

const ClientCalendarComp = ({ onDateSelect, selectedDate }) => {
  const initialDate = selectedDate ? new Date(selectedDate) : new Date();
  const [startDate, setStartDate] = useState(initialDate);

  // const [startDate, setStartDate] = useState(new Date());
  // const open = Boolean(anchorEl);

  const clientformatDate = (date) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const handleChange = (date) => {
    setStartDate(date);
    if (onDateSelect) {
      onDateSelect(clientformatDate(date)); // pass selected date to parent
      // onClose();
    }
  };
  return (
    <>
      <div className="datepicker-wrapper" style={{ padding: "8px" }}>
        <DatePicker
          selected={startDate}
          onChange={handleChange}
          inline
          minDate={(() => {
            const minDate = new Date();
            minDate.setHours(0, 0, 0, 0);
            let daysAdded = 0;
            while (daysAdded < 5) {
              minDate.setDate(minDate.getDate() + 1);
              if (minDate.getDay() !== 0) {
                daysAdded++;
              }
            }
            return minDate;
          })()}
          excludeDates={[
            new Date(),
            (() => {
              const d = new Date();
              d.setDate(d.getDate() + 1);
              return d;
            })(),
          ]}
          filterDate={(date) => date.getDay() !== 0}
          fixedHeight
          renderCustomHeader={({ date, changeYear, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
            <CalendarHeader
              date={date}
              changeYear={changeYear}
              decreaseMonth={decreaseMonth}
              increaseMonth={increaseMonth}
              prevMonthButtonDisabled={prevMonthButtonDisabled}
              nextMonthButtonDisabled={nextMonthButtonDisabled}
            />
          )}
        />
      </div>
    </>
  );
};

export default ClientCalendarComp;
